import { object } from 'yup';
import type { ReportChartConfiguration } from '@vision/ui/interfaces';
import { DefaultReportChartThemeFont } from '../../constants/default-chart.config';
import { BenchmarkMatrixControls } from './BenchmarkMatrixControls';

export const benchmarkMatrixConfig: ReportChartConfiguration = {
  fetchesOwnData: true,
  validationSchema: object(),
  measures: null,
  hideCompare: true,
  hideFilters: true,
  themeComponentHide: true,
  compareRendererComponent: null,
  chartValueComponent: BenchmarkMatrixControls,
  customize: { hide: true },
  defaultTheme: { title: { ...DefaultReportChartThemeFont, label: '' } },
};
